/**************************************************************************************************
//
//  Description:  API wrapper
//
//  Copyright:    © 2020-21 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue#  Description
//#region Version 1.0.0.0 changes
//    001   22.02.21 Joel Benford        WI39069 Initial Revision.
//    002   12.03.21 Sean Flook          WI39628 Added getLastExportDateAsync.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion */

//#region imports
import { GetOSGSwaOrgRefs_URL, GetLocalities_URL, GetTowns_URL, GetAdministrativeAreas_URL, GetStreetRefs_URL, GetOSGLanguages_URL, GetLookupsLastChangedURL, GetLastExportDateURL } from '../configuration/AAConfig';
//#endregion imports

// lookups methods
export const getLastExportDateAsync = async () => await fetchDataAsync(await GetLastExportDateURL());
export const getLookupsLastChangedAsync = async () => await fetchDataAsync(await GetLookupsLastChangedURL());
export const getAdministrativeAreasAsync = async () => await fetchDataAsync(await GetAdministrativeAreas_URL());
export const getLocalitiesAsync = async () => await fetchDataAsync(await GetLocalities_URL());
export const getOSGLanguagesAsync = async () => await fetchDataAsync(await GetOSGLanguages_URL());
export const getOSGSwaOrgRefsAsync = async () => await fetchDataAsync(await GetOSGSwaOrgRefs_URL());
export const getStreetRefsAsync = async () => await fetchDataAsync(await GetStreetRefs_URL());
export const getTownsAsync = async () => await fetchDataAsync(await GetTowns_URL());


//Does the actual API get
//urlDetails is a data structure returned by configuration/AAConfig.js methods like GetLocalities_URL()
//e.g. { "url": 'https://localhost:44321//api/StreetLookup/GetLocalities', "type": "GET", "headers": [{ "Content-Type": "text/plain" }] }
const fetchDataAsync = async (urlDetails) => {
  const url = urlDetails.url;
  return await fetch(url)
    .then(response => response.json())
    .then(result => { return result; })
    .catch(e => { console.log(e); });
};
